

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.addButtonPrice();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      // Shows the price (and struck-through compare price) on the right of the popup's floating
      // Add to cart button, like the product page's sticky bar. Kept in sync on variant change,
      // when product-info re-renders the price block.
      addButtonPrice() {
        const button = this.modalContent.querySelector('.product-form__submit');
        const priceBlock = this.modalContent.querySelector('[id^="price-"]');
        if (!button || !priceBlock) return;

        const tag = document.createElement('span');
        tag.className = 'quick-add__button-price';
        button.appendChild(tag);

        const sync = () => {
          const price = priceBlock.querySelector('.price');
          if (!price) return;
          const onSale = price.classList.contains('price--on-sale');
          const current = onSale
            ? price.querySelector('.price__sale .price-item--sale')
            : price.querySelector('.price__regular .price-item--regular');
          const compare = onSale ? price.querySelector('.price__sale s.price-item--regular') : null;
          tag.textContent = current ? current.textContent.trim() : '';
          if (compare && compare.textContent.trim()) {
            const s = document.createElement('s');
            s.textContent = compare.textContent.trim();
            tag.appendChild(s);
          }
          tag.hidden = !tag.textContent;
        };

        sync();
        new MutationObserver(sync).observe(priceBlock, { childList: true, subtree: true, characterData: true });
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        // The product page's sticky Add To Cart bar starts on DOMContentLoaded, which has already
        // fired here, so inside the popup its button would do nothing. The popup has its own form.
        const stickyATC = productElement.querySelector('#MobileStickyATC');
        if (stickyATC) stickyATC.remove();
        productElement.querySelectorAll('script').forEach((script) => {
          if (script.textContent.includes('MobileStickyATC')) script.remove();
        });
        // Its <style> hides .product-form__buttons on phones, which would hide the popup's own buttons.
        productElement.querySelectorAll('style').forEach((style) => {
          if (style.textContent.includes('mobile-sticky-atc')) style.remove();
        });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}


